import React, { Component } from "react";
import AudioWorkFooterRender from "./children/AudioWorkFooterRender";
import sentGAEvent from "@/ga";
import "@/assets/audioAddMusic.less";

class AudioWorkFooterFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      format: "mp3",
    };
  }

  handleFormatChange = value => {
    this.setState({
      format: value,
    });
  };

  render() {
    return (
      <AudioWorkFooterRender
        handleSubmit={format => {
          this.props.handleSubmit(format);
          sentGAEvent({
            category: "add_music_output",
            action: "add_music_export_click",
          });
        }}
        format={this.state.format}
        handleFormatChange={this.handleFormatChange}
      />
    );
  }
}

export default AudioWorkFooterFunction;
